export enum DockZoneTypes {
    CallInToDock = "CallInToDock",
    Dock = "Dock",
    CallOutToDock = "CallOutToDock",
    None = "None"
}